var map = {
	"./company_incoporation.png": "d4c6",
	"./company_secretarial.png": "2991",
	"./employer_registration.png": "be0d",
	"./icon-audit.png": "f3c6",
	"./icon-files.png": "e88d",
	"./icon-payroll.png": "cbe2",
	"./icon-services.png": "2411",
	"./icon-stamp.png": "dd47",
	"./icon-statements.png": "df67",
	"./icon-tax.png": "3087",
	"./moving_forward.png": "8bb6",
	"./moving_forward_mobile.png": "6539",
	"./payroll_processing.png": "6560",
	"./tax.png": "bfc5",
	"./training.png": "cf39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "70ad";